var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 676,
    viewBox: "0 0 676 676",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 676,
    height: 676,
    rx: 338,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.07 186.799C475.634 186.799 474.16 187.063 472.686 187.668L254.833 275.202H192.848C189.522 275.202 186.801 277.999 186.801 281.477V394.485C186.801 397.962 189.522 400.759 192.848 400.759H231.286C229.888 405.143 229.132 409.792 229.132 414.517C229.132 439.424 249.466 459.682 274.486 459.682C295.425 459.682 313.076 445.471 318.291 426.271L472.724 488.331C474.198 488.898 475.672 489.201 477.108 489.201C483.495 489.201 489.203 483.834 489.203 476.652V199.347C489.165 192.166 483.495 186.799 477.07 186.799ZM274.486 432.583C264.471 432.583 256.344 424.495 256.344 414.517C256.344 410.284 257.819 406.239 260.502 403.027L292.59 415.915C291.834 425.213 284.011 432.583 274.486 432.583V432.583ZM461.952 454.655L264.962 375.512L260.086 373.546H214.014V302.415H260.086L264.962 300.45L461.952 221.306V454.655V454.655Z",
    fill: "#2D9CDB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifLogo);
export default __webpack_public_path__ + "static/media/notif-logo.01217aa0593d011e5f13d252b30c8b74.svg";
export { ForwardRef as ReactComponent };